import { render, staticRenderFns } from "./SocialNetworks.vue?vue&type=template&id=db156212&scoped=true"
import script from "./SocialNetworks.vue?vue&type=script&lang=js"
export * from "./SocialNetworks.vue?vue&type=script&lang=js"
import style0 from "./SocialNetworks.vue?vue&type=style&index=0&id=db156212&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db156212",
  null
  
)

export default component.exports